import React from 'react';
import Modal from '../../../../../components/Modal';
import Tag from '../../../../../components/tag/Tag';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { openNewWindow, setDetailPageUrl } from '../../../../../lib/common';

const ProductSubCategoryListViewModal = (props) => {
  const { isOpen, data, closeModal } = props;
  const { productSubCategoryList } = data;

  return (
    <Modal
      title="2차 카테고리 보기"
      isOpen={isOpen}
      width={350}
      height={350}
      isFooter={false}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      {productSubCategoryList.map((item) => (
        <Tag
          isAddHash={false}
          key={item.id}
          text={item.name}
          onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, item.id))}
        />
      ))}
    </Modal>
  );
};

export default ProductSubCategoryListViewModal;
